import { useEffect, useState } from "react";
import { scrollToId } from "../../utils/scroll";
import "./scrollToTop.css";

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      className={["totop", visible ? "is-visible" : ""].join(" ")}
      onClick={() => scrollToId("home")}
      aria-label="回到顶部"
    >
      <span aria-hidden>↑</span>
    </button>
  );
}

